import { requestGetAuthorization } from "../../../../services/requestGet";
import {
  setRetrieveBannerMain,
  setRetrieveBannerMainLoading,
} from "./mainSlice";

function transformData(data) {
  const transformedData = {};
  for (const key in data) {
    if (Array.isArray(data[key]) && key === "photo") {
      const photosArray = [];
      data[key].forEach((photoObject) => {
        const url = photoObject.photo;
        const name = url.substring(url.lastIndexOf("/") + 1);
        const slug = photoObject.slug;
        photosArray.push({
          url,
          type: "",
          name,
          slug,
        });
      });
      transformedData[key] = photosArray;
    } else if (!Array.isArray(data[key])) {
      transformedData[key] = {
        url: data[key],
        type: "",
        name: data[key].substring(data[key].lastIndexOf("/") + 1),
      };
    } else {
      transformedData[key] = data[key];
    }
  }
  return transformedData;
}

export const getRetrieveBannerMain = () => {
  return async (dispatch) => {
    dispatch(setRetrieveBannerMainLoading({ showLoading: true }));
    const token = localStorage.getItem("token");
    requestGetAuthorization(`admin/banners/cafeterias/`, token).then(
      (value) => {
        const transformedData = transformData(value);
        dispatch(setRetrieveBannerMain({ data: transformedData }));
        dispatch(setRetrieveBannerMainLoading({ showLoading: false }));
      }
    );
  };
};
